import { format } from "date-fns/esm";

import { SearchRequest } from "api/SearchRequest";
import { YN_TYPE } from "types/enumType";

export class LotoOrderSearchRequest extends SearchRequest {
  startDate: string;

  endDate: string;

  deptId: string = '';

  equipName: string = '';

  role: string = '';

  inHouseYn: YN_TYPE | string = '';

  lockedYn: YN_TYPE | string = '';

  oldLotoYn: YN_TYPE | string;

  selfCreateYn: YN_TYPE | string;

  transferYn?: YN_TYPE | string;

  constructor(page: number, count: number, localId: string, factoryId: string, isClearDate: boolean = false, selfCreateYn: YN_TYPE | string = '', oldLotoYn: YN_TYPE | string = '') {
    super(page, count, localId, factoryId);

    const weekAgoDate = new Date();
    weekAgoDate.setFullYear(weekAgoDate.getMonth() - 1);
    this.startDate = isClearDate ? '' : format(weekAgoDate, 'yyyy-MM-dd');
    const tomorrow = new Date();
    tomorrow.setMonth(tomorrow.getMonth() + 1);
    this.endDate = isClearDate ? '' : format(tomorrow, 'yyyy-MM-dd');

    this.selfCreateYn = selfCreateYn;
    this.oldLotoYn = oldLotoYn;
  }
}